import type { LoginDataDto } from 'utils/types/user';
import Cookies from 'js-cookie';


export function handleSetData(loginDataDto: LoginDataDto) {
	const { user_id, email, role } = loginDataDto;

	Cookies.set("role", role, {
		expires: 1, // 1 день
		secure: process.env.REACT_APP_NODE_ENV !== "local",
		sameSite: "Strict",
		path: "/"
	});
	Cookies.set("user_id", user_id, {
		expires: 1, // 1 день
		secure: process.env.REACT_APP_NODE_ENV !== "local",
		sameSite: "Strict",
		path: "/"
	});

	if (!window.db_userId) window.db_userId = user_id;
	if (!window.userEmail) window.userEmail = email;
}
